import React from "react";
import { DashboardStats } from "../../../Types/Dashboard";
import { FaUsers, FaBook, FaShoppingCart, FaDollarSign, FaCalendarDay, FaCalendarWeek } from "react-icons/fa";

interface StatCardsProps {
  stats: DashboardStats;
  loading?: boolean;
}

export default function StatCards({ stats, loading }: StatCardsProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-6">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="bg-white rounded-lg shadow p-6 animate-pulse"
          >
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
            <div className="h-8 bg-gray-200 rounded w-1/2"></div>
          </div>
        ))}
      </div>
    );
  }

  const cards = [
    {
      title: "Total Utilisateurs",
      value: stats.users.total,
      icon: <FaUsers className="text-2xl text-blue-500" />,
      bgColor: "bg-blue-50",
      textColor: "text-blue-600",
    },
    {
      title: "Total Sessions",
      value: stats.bookings.total,
      icon: <FaBook className="text-2xl text-green-500" />,
      bgColor: "bg-green-50",
      textColor: "text-green-600",
    },
    {
      title: "Total Commandes",
      value: stats.orders.total,
      icon: <FaShoppingCart className="text-2xl text-purple-500" />,
      bgColor: "bg-purple-50",
      textColor: "text-purple-600",
    },
    {
      title: "Revenus Totaux",
      value: `$${stats.revenue.total.toLocaleString()} USD`,
      icon: <FaDollarSign className="text-2xl text-yellow-500" />,
      bgColor: "bg-yellow-50",
      textColor: "text-yellow-600",
    },
    {
      title: "Sessions Aujourd'hui",
      value: stats.bookings.today,
      icon: <FaCalendarDay className="text-2xl text-orange-500" />,
      bgColor: "bg-orange-50",
      textColor: "text-orange-600",
    },
    {
      title: "Sessions Cette Semaine",
      value: stats.bookings.this_week,
      icon: <FaCalendarWeek className="text-2xl text-indigo-500" />,
      bgColor: "bg-indigo-50",
      textColor: "text-indigo-600",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-6">
      {cards.map((card, index) => (
        <div
          key={index}
          className={`${card.bgColor} rounded-lg shadow p-6 hover:shadow-lg transition-shadow`}
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`${card.textColor} font-semibold text-sm`}>
              {card.title}
            </div>
            {card.icon}
          </div>
          <div className={`${card.textColor} text-2xl font-bold`}>
            {card.value}
          </div>
        </div>
      ))}
    </div>
  );
}
